import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Input } from "antd";
import {
  dataLayerViewedEvent,
  tagManagerEvent,
} from "event-tracker/gtm-events";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

type Item = {
  label: string;
  value: string;
};

type ListFieldProps = {
  value?: string;
  onChange?: (option?: string) => void;
  placeholder?: string;
  label?: string;
  options?: Item[];
  onClickNext?: () => void;
  name?: string;
};

const ListField: React.FC<ListFieldProps> = (props) => {
  const {
    value,
    onChange = (_: any) => {},
    placeholder,
    label,
    options,
    name,
    onClickNext,
  } = props;

  const { t } = useTranslation();
  const [searchField, setSearchField] = useState<string>("");
  const [optionsList, setOptionsList] = useState<Item[]>(options || []);
  const [visibleCount, setVisibleCount] = useState<number>(1000);

  const onClickContinue = () => {
    if (onClickNext) onClickNext();
  };

  const onSelectItem = (option: string) => {
    onChange(option);
  };

  const onClickMore = () => {
    setVisibleCount((prevCount) => prevCount + 10);
  };

  useEffect(() => {
    setOptionsList(
      options
        ?.filter((option) =>
          option.label.toLowerCase().includes(searchField.toLowerCase())
        )
        .slice(0, visibleCount) || []
    );
  }, [searchField, options, visibleCount]);

  useEffect(() => {
    if (name === "genre") {
      dataLayerViewedEvent({
        ...tagManagerEvent.FreeAssessment.GENRE_SELECTION_NEW_ASSESSMENT,
        version: "V3",
      });
    }
    if (name === "countryCode") {
      dataLayerViewedEvent({
        ...tagManagerEvent.FreeAssessment.COUNTRY_SELECTION_NEW_ASSESSMENT,
        version: "V3",
      });
      return;
    }
  }, [name]);

  const Footer = () => {
    return (
      <div className="footer">
        <Button
          className="botao-roxo"
          onClick={onClickContinue}
          disabled={!value}
        >
          {t("quiz.pages.FreeAssessment.continue")}
        </Button>
      </div>
    );
  };

  return (
    <>
      <h1>{label}</h1>
      <Input
        placeholder={placeholder}
        value={searchField}
        onChange={(e) => setSearchField(e.target.value)}
        allowClear
        suffix={<FontAwesomeIcon icon={faSearch} color="#5A57FF" />}
      />
      <div className="full-item list-field">
        <div className="list">
          {optionsList?.map((option) => (
            <div
              key={option.value}
              className={`item ${value === option.value ? "active" : ""}`}
              onClick={() => onSelectItem(option.value)}
            >
              <span>{option.label}</span>
            </div>
          ))}
          {optionsList.length < (options?.length || 0) && !searchField && (
            <div
              className="item"
              style={{ justifyContent: "center", marginBottom: 10 }}
              onClick={onClickMore}
            >
              {t("quiz.pages.FreeAssessment.more")}
            </div>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ListField;
